import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const Order = () => {
    document.title = "Sifariş";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Alışlar", value: "/supplies" },
        { name: "Sifariş", value: "/supplies/order", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sifariş</h2>
                    <p>
                        Alışın sifarişi, Təchizatçılara verilən sifarişlər üçün nəzərdə tutulub. Sifariş sənədini açıb statusu dəyişmək və Yeni satış düyməsini
                        sıxıb, sifariş sənədini satış sənədinə verimək olar. <SaveButton /> düyməsini sıxıb satış sənədini formalaşdırmaq olar.
                    </p>
                    <img src="/images/supplies/order.gif" alt="Sifariş" />
                </article>
            </div>
        </div>
    );
};
